import { z } from 'zod';

export const activateSubscriptionTokenRequestSchema = z.object({
  entitlement: z.object({
    id: z.string(),
    startedAt: z.date(),
    endedAt: z.date().optional(),
    active: z.boolean(),
  }),
});

export type ActivateSubscriptionTokenRequest = z.infer<typeof activateSubscriptionTokenRequestSchema>;

export const createSubscriptionTokenResponseSchema = z.object({ tokenId: z.string() });
